<template>
  <div>
    <div class="row">
      <div class="col-6">
        <q-uploader
          extensions=".gif,.jpg,.jpeg,.png"
          v-show="showUploader"
          ref="uploadwidget"
          :url="fullApiUploadUrl"
          method="POST"
          v-bind="componentProps"
          :before="beforeIcons"
          @uploaded="handleUploadComplete"
          @fail="handleFail"
          @add="handleAdd"
          :hide-upload-button="!theModelId"
          @remove:abort="handleRemove"
          @remove:cancel="handleRemove"
        ></q-uploader>
        <q-btn-group v-show="!!value && !showUploader" v-if="!!value" push>
          <q-btn color="primary" push icon="file download" @click="handleDownload">
            <q-tooltip>Download File</q-tooltip>
          </q-btn>
          <q-btn color="secondary" push icon="file upload" @click="showUploader=true">
            <q-tooltip>Upload File</q-tooltip>
          </q-btn>
          <q-btn color="negative" push icon="delete" @click="handleDelete">
            <q-tooltip>Delete File</q-tooltip>
          </q-btn>
        </q-btn-group>
      </div>
      <div class="col-6 text-right">
        <a v-if="value && typeof value === 'string' && value.startsWith('http')" :href="value" target="_blank"><img class="flex inline shadow-box flex-center shadow-6" :src="value" style="max-height:36px; width: auto;" /></a>
      </div>
    </div>
  </div>
</template>
<script>
import { extend } from 'quasar'

const API_BASE_URL = process.env.API_BASE_URL
export default {
  name: 'FileUploadField',
  props: {
    resource: String,
    column: Object,
    value: {
      default: () => ''
    },
    modelId: {
      type: [Number, String],
      default: () => ''
    }
  },
  data () {
    return {
      error: null,
      // showUploader: !!this.value,
      showUploader: this.value ? false : true,
      theModelId: this.modelId,
      userAddedFile: false,
      model: {}
    }
  },
  computed: {
    // showUploader () {
    //   if (this.value) {
    //     return false
    //   }
    //   return true
    // },
    componentProps () {
      return extend(true, {}, this.column.component.props, {
        headers: this.headers,
        additionalFields: this.additionalFields
      })
    },
    beforeIcons () {
      return [
        {
          icon: 'cancel',
          handler: this.toggleUploader,
          content: !this.value
        }
      ]
    },
    fullApiUploadUrl () {
      const apiEndpoint = this.apiEndpoint
      const id = this.theModelId
      return `${API_BASE_URL}${apiEndpoint}/uploadfile/${id}`
    },
    fullApiDeleteUrl () {
      const apiEndpoint = this.apiEndpoint
      const id = this.theModelId
      return `${API_BASE_URL}${apiEndpoint}/deletefile/${id}`
    },
    apiEndpoint () {
      return this.$store.state[this.resource].apiEndpoint
    },
    downloadUrl () {
      return this.value
      /*
      const token = this.token
      const apiEndpoint = this.apiEndpoint
      const id = this.theModelId
      if (this.column && this.column.component && this.column.component.media) {
        const mediaCollection = this.column.component.media
        if (mediaCollection && id && token) {
          return `${API_BASE_URL}/download${apiEndpoint}/${id}?token=${token}&media=${mediaCollection}`
        }
      } else {
        const message = 'ERROR: Model does not have a media collection in column definition'
        this.$q.notify({
          type: 'negative',
          message
        })
      }
      return null
       */
    },
    token () {
      return this.$store.getters['auth/token']
    },
    headers () {
      return {
        Authorization: `Bearer ${this.token}`,
        Accept: 'application/json'
      }
    },
    additionalFields () {
      return [
        {
          name: 'field',
          value: this.column.field
        },
        {
          name: 'id',
          value: this.theModelId
        }
      ].concat(this.column.component.props.additionalFields)
    }
  },
  methods: {
    toggleUploader () {
      this.showUploader = !this.showUploader
    },
    async handleDownload () {
      this.$download(this.value)
    },
    async deleteFile () {
      // console.log(this.column.component.media)
      try {
        await this.$axios.post(this.fullApiDeleteUrl, {
          media: this.column.component.media
        })
        this.$q.notify({
          type: 'positive',
          message: 'File has been removed'
        })
        this.$emit('change', '')
        this.showUploader = true
      } catch (e) {
        const message = `ERROR: Could not delete file: ${e.message}`
        this.$q.notify({
          type: 'negative',
          message
        })
      }
    },
    async handleDelete () {
      this.$q
        .dialog({
          title: 'Confirm Delete File',
          message: 'Are you sure you want to remove this file?',
          ok: {
            label: 'Remove File',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          this.deleteFile()
        })
        .catch(() => {})
    },
    triggerSelect () {
      this.$refs.uploadwidget.$refs.file.click()
    },
    triggerUpload (params) {
      // console.log('triggerUpload', params)
      if (!this.userAddedFile) {
        return this.$emit('async-complete', this.column)
      }
      if (this.value) {
        // console.log('>> init upload', params)
        const { id, model, resource } = params.payload
        if (this.resource === resource) {
          if (id) {
            this.theModelId = id
          }
          if (model) {
            this.model = model
          }
          this.$emit('async-init', this.column)
          this.$nextTick(() => {
            this.$refs.uploadwidget.upload()
          })
        }
      } else {
        // console.log('triggerUpload NO VALUE')
        this.$emit('async-complete', this.column)
      }
    },
    handleUploadComplete (file, xhr) {
      this.$q.notify({
        type: 'positive',
        message: 'Upload complete'
      })
      // console.log('file, xhr', file, xhr)
      const response = JSON.parse(xhr.response)
      // console.log('response', response[this.column.name])
      this.$emit('change', response[this.column.name])
      this.toggleUploader()
      this.$emit('async-complete', this.column)
    },
    handleAdd (files) {
      this.userAddedFile = true
      if (this.column.component.multiple) {
        // this.$emit('input', files)
        this.$root.$emit('update-form', this.column.field, files)
      } else {
        // this.$emit('input', files[0])
        this.$root.$emit('update-form', this.column.field, files[0])
      }
    },
    handleRemove (file) {
      this.userAddedFile = false
      // console.log('file', file)
      this.$emit('input', '')
    },
    handleFail (file, xhr) {
      // console.log('FAIL')
      // console.log('file', file)
      // console.log('xhr', xhr)
    }
  },
  created () {
    this.$root.$on('trigger_upload', this.triggerUpload)
  },
  beforeDestroy () {
    this.$root.$off('trigger_upload', this.triggerUpload)
  },
  watch: {
    id (newId) {
      if (newId) {
        this.$set(this, 'theModelId', newId)
        // console.log('has new theModelId!', newId)
      }
    },
    value (newValue) {
      this.showUploader = newValue && typeof newValue === 'string' ? false : true
    }
  }
}
</script>
<style lang="stylus" scoped>
.uploader-box {
  border: 1px dashed;
  width: 100%;
}

.q-input-target {
  display: none !important;
}
</style>
